import React from 'react'
import Typography from '../../Typography'
import * as Styled from './NameAndDescription.styles'

const NameAndDescription = ({ name = null, description = null }) => (
  <div>
    {name && (
      <Styled.Name>
        <Typography
          variant="h5"
          className={`title ${description && 'collapse-bottom-spacing'}`}
          dangerouslySetInnerHTML={{ __html: `${name}`.trim() }}
        />
      </Styled.Name>
    )}
    {description && (
      <Styled.Description>
        <Typography
          variant=""
          className="description"
          dangerouslySetInnerHTML={{
            __html: `${description}`.trim(),
          }}
        />
      </Styled.Description>
    )}
  </div>
)

/* eslint-enable react/no-danger */
export default NameAndDescription
